import { render, staticRenderFns } from "./enviar-chave-de-acesso.vue?vue&type=template&id=cc5dcd76&"
import script from "./enviar-chave-de-acesso.vue?vue&type=script&lang=js&"
export * from "./enviar-chave-de-acesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports